import React from "react";

import "./ContentCenterColumnBox.css";
export const ContentCenterColumnBox = ({
  children,
}: React.PropsWithChildren) => {
  return <div className="content-center-column-box">{children}</div>;
};
